import React from 'react';
import civiImg from '../assets/civi-transparent.png';

/**
 * AIOrb — the iconic Hey CIVIX avatar (Civi, the 3D mascot character).
 * Uses the rendered Civi character image with a glowing aura backdrop.
 */
export default function AIOrb({ size = 180, animate = true, className = '', glow = true }) {
  return (
    <div
      className={`relative inline-flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
    >
      {glow && (
        <div
          className={`absolute inset-0 rounded-full ${animate ? 'animate-pulse-slow' : ''}`}
          style={{
            background:
              'radial-gradient(circle at 50% 45%, rgba(139, 92, 246, 0.55) 0%, rgba(34, 211, 238, 0.25) 45%, transparent 70%)',
            filter: 'blur(8px)',
          }}
        />
      )}
      <img
        src={civiImg}
        alt="Civi — CIVIX AI Assistant"
        className="relative z-10 w-full h-full object-contain drop-shadow-[0_0_22px_rgba(139,92,246,0.55)]"
        style={{ pointerEvents: 'none' }}
      />
    </div>
  );
}
